<template>
  <div style="width:100%;height:100%">
    <div ref="chart" style="width:100%;height:100%"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  // mounted() {
  //   this.getEchartData()
  // },
  methods: {
    getEchartData(data) {
      console.log(data,'data');
      if(!data&&!Array.isArray(data))return;
      const chart = this.$refs.chart
      if (chart) {
        const myChart = this.$echarts.init(chart)
        const option = {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              lineStyle: {
                color: "#ddd",
              },
            },
            backgroundColor: "rgba(255,255,255,1)",
            padding: [5, 10],
            textStyle: {
              color: "#274A93",
            },
            extraCssText: "box-shadow: 0 0 5px rgba(0,0,0,0.3)",
          },
          grid:{
            left:"10%",
            top:"20%",
            right:"5%",
            bottom:"20%"
          },
          legend: {
            left: 20,
            // orient: "vertical",
            data: ["事件总数", "办结总数"],
            textStyle: {
              fontSize: 12,
              color: "#AAD5FD",
            },
          },
          xAxis: {
            type: "category",
            data: data.map(e=>e.rqd),
            boundaryGap: true,
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: "#B1C8CF",
              },
            },
            axisLabel: {
              // rotate:-10,
              // margin: 10,
              textStyle: {
                fontSize: 12,
              },
            },
          },
          yAxis: {
            type: "value",
            splitLine: {
              lineStyle: {
                color: ['#203654'],
              },
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: "#B1C8CF",
              },
            },
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 14,
              },
            },
          },
          // dataZoom: [
          //   {
          //     show: true, // 为true 滚动条出现
          //     realtime: true,
          //     type: 'slider', // 有type这个属性，滚动条在最下面，也可以不行，写y：36，这表示距离顶端36px，一般就是在图上面。
          //     startValue: 0, // 表示默认展示20%～80%这一段。
          //     endValue: 6,
          //     right: "2%",
          //     left: "2%",
          //     bottom: '0%',       //位置和grid配置注意下
          //     height: 6,
          //     xAxisIndex: 0,     //关联多个y轴
          //     moveHandleStyle: {
          //         color: "rgba(89, 202, 241,.5)",
          //     },
          //     moveHandleSize: "6",
          //     emphasis: {
          //         moveHandleStyle: {
          //           color: "rgba(89, 202, 241,.5)",
          //         }
          //     },
          //     textStyle: {
          //         color: "rgba(255,255,255,0)",
          //     },
          //     backgroundColor: '#00000000',
          //     borderColor: "rgba(255,255,255,0)",
          //     fillerColor: "rgba(0,0,0,0)",
          //     handleSize: "0",
          //     handleStyle: {
          //         color: "rgba(255,255,255,0)"
          //     },
          //     brushStyle: {
          //         color: "rgba(129, 243, 253)"
          //     }
          //   },
          //   {//没有下面这块的话，只能拖动滚动条，鼠标滚轮在区域内不能控制外部滚动条
          //     type: 'inside',
          //     xAxisIndex: 0,
          //     zoomOnMouseWheel: true,  //滚轮是否触发缩放
          //     moveOnMouseMove: false,  //鼠标滚轮触发滚动
          //     moveOnMouseWheel: true
          //   }
          // ],
          series: [
            {
              name: "事件总数",
              type: "line",
              smooth: true,
              showSymbol: true,
              symbol: "circle",
              symbolSize: 8,
              // data: [
              //   "5",
              //   "8",
              //   "14",
              //   "3",
              //   "8",
              //   "12",
              //   "1",
              // ],
              data: data.map(e=>e.js_count),
              areaStyle: {
                normal: {
                  color: this.$echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1,
                    [
                      {
                        offset: 0,
                        color: "rgba(92,111,255,0.5)",
                      },
                      {
                        offset: 1,
                        color: "rgba(92,111,255,0.2)",
                      },
                    ],
                    false
                  ),
                  shadowColor:"rgba(92,111,255,0.5)",
                },
              },
              itemStyle: {
                color: "#53FFFF",
                borderColor: "#fff",
                borderWidth: 1,
                shadowColor: "rgba(0, 0, 0, .3)",
                shadowBlur: 0,
                shadowOffsetY: 2,
                shadowOffsetX: 2,
              },
              lineStyle: {
                normal: {
                  width: 3,
                },
              },
            },
            {
              name: "办结总数",
              type: "line",
              smooth: true,
              showSymbol: true,
              symbol: "circle",
              symbolSize: 8,
              // data: [
              //   "6",
              //   "5",
              //   "11",
              //   "10",
              //   "6",
              //   "1",
              //   "5",
              // ],
              data: data.map(e=>e.bj_count),
              areaStyle: {
                normal: {
                  color: this.$echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1,
                    [
                      {
                        offset: 0,
                        color: "rgba(82,241,255,0.5)",
                      },
                      {
                        offset: 1,
                        color: "rgba(82,241,255,0.2)",
                      },
                    ],
                    false
                  ),
                  shadowColor:"rgba(82,241,255,0.5)",
                },
              },
              itemStyle: {
                color: "#5F69FF",
                borderColor: "#fff",
                borderWidth: 1,
                shadowColor: "rgba(0, 0, 0, .3)",
                shadowBlur: 0,
                shadowOffsetY: 2,
                shadowOffsetX: 2,
              },
              lineStyle: {
                normal: {
                  width: 3,
                },
              },
            },
          ],
        };
        myChart.setOption(option)
        window.addEventListener("resize", function () {
          myChart.resize()
        })
      }
      this.$on('hook:destroyed', () => {
        window.removeEventListener("resize", function () {
          myChart.resize();
        });
      })
    },
  },
}
</script>